import React, { useState } from "react";
import Table from "../../../components/TableTwo";
import { USER_LOG } from "../../../navigation/routes";
import makeData from "../../../utils/makeData";

const AdminLogs = () => {
    const [currentView, setCurrentView] = useState('main')
    const [callData, setCallData] = React.useState(React.useMemo(() => makeData('call history', 15), []))
    const [skipPageReset] = React.useState(false)

    const columnCalls = React.useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Duration(mm:ss)',
                accessor: 'duration',
            },
            {
                Header: 'Date',
                accessor: 'date',
            },
            {
                Header: 'Time',
                accessor: 'time'
            }
        ],
        []
    )
    const columnMessages = React.useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Subject',
                accessor: 'subject',
            },
            {
                Header: 'Type',
                accessor: 'type',
            },
            {
                Header: 'Date',
                accessor: 'messagedate'
            }
        ],
        []
    )
    const columnCallRecords = React.useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'id',
            },
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Contact no',
                accessor: 'contactno',
            },
            {
                Header: 'Call type',
                accessor: 'calltype',
            },
            {
                Header: 'Call type',
                accessor: 'callcenter',
            },
            {
                Header: 'Duration(mm:ss)',
                accessor: 'duration',
            },
            {
                Header: 'Date',
                accessor: 'date',
            },
            {
                Header: 'Time',
                accessor: 'time'
            },
            {
                Header: 'Total Calls',
                accessor: 'totalcalls'
            },
            {
                Header: 'Action',
                accessor: 'action',
                Cell: row => (
                    <div className="flex flex-wrap gap-2 w-100">
                        <button className="btn btn-secondary" ><i className="fas fa-phone" /></button>
                    </div>
                ),
            }
        ],
        []
    )

    const columnMessageRecords = React.useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'id',
            },
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Contact Address',
                accessor: 'email',
            },
            {
                Header: 'Message Type',
                accessor: 'type',
            },
            {
                Header: 'CRM Id',
                accessor: 'crmid',
            },
            {
                Header: 'Date',
                accessor: 'date',
            },
            {
                Header: 'Time',
                accessor: 'time'
            },
            {
                Header: 'Total messages',
                accessor: 'totalcalls'
            },
            {
                Header: 'Action',
                accessor: 'action',
                Cell: row => (
                    <div className="flex flex-wrap gap-2 w-100">
                        <button className="btn btn-primary" ><i className="fas fa-envelope" /></button>
                    </div>
                ),
            }
        ],
        []
    )
    return (
        <>
            <div className="container-fluid px-4">
                <div className="d-sm-flex align-items-start justify-content-between mt-4">
                    <div>
                        <h1>Call/Sms Center</h1>
                        <ol className="breadcrumb mb-2">
                            <li className="breadcrumb-item"><a href={USER_LOG}>Call/Sms Center</a></li>
                            <li className="breadcrumb-item active">ActionAid Admins</li>
                            <li className="breadcrumb-item active">{currentView === 'main' ? 'Dashboard' : 'Logs'}</li>
                        </ol>
                    </div>
                    <div
                        className="d-flex align-items-center justify-content-end mb-2">
                        <button className="btn btn-primary" onClick={() => currentView === 'main' ? setCurrentView('log') : setCurrentView('main')}>{currentView === 'main' ? 'View Logs' : 'View call dashboard'}</button>
                    </div>
                </div>
                {currentView === 'main' && <div className="row">
                    <div className="col-xl-3 col-md-6">
                        <div className="card bg-success text-white mb-4">
                            <div className="card-header">Call History</div>
                            <div className="card-body d-flex flex-column">
                                <span className="small text-white stretched-link">Incoming Calls: 150</span>
                                <span className="small text-white stretched-link">Outgoing calls :		280</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <div className="card bg-danger text-white mb-4">
                            <div className="card-header">Messages</div>
                            <div className="card-body d-flex flex-column">
                                <span className="small text-white stretched-link">SMS: 150</span>
                                <span className="small text-white stretched-link">Emails: 280</span>
                            </div>
                        </div>
                    </div>
                </div>}
                {currentView === 'main' && <>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card mb-4">
                                <div className="card-header">
                                    <i className="fas fa-table me-1"></i>
                                    Total calls
                                </div>
                                <div className="card-body">
                                    <Table
                                        columns={columnCalls}
                                        data={callData}
                                        setData={setCallData}
                                        skipPageReset={skipPageReset}
                                        pagesize={5}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card mb-4">
                                <div className="card-header">
                                    <i className="fas fa-table me-1"></i>
                                    Incoming calls
                                </div>
                                <div className="card-body">
                                    <Table
                                        columns={columnCalls}
                                        data={callData}
                                        setData={setCallData}
                                        skipPageReset={skipPageReset}
                                        pagesize={5}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card mb-4">
                                <div className="card-header">
                                    <i className="fas fa-table me-1"></i>
                                    Outgoing calls
                                </div>
                                <div className="card-body">
                                    <Table
                                        columns={columnCalls}
                                        data={callData}
                                        setData={setCallData}
                                        skipPageReset={skipPageReset}
                                        pagesize={5}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card mb-4">
                                <div className="card-header">
                                    <i className="fas fa-table me-1"></i>
                                    Messages History
                                </div>
                                <div className="card-body">
                                    <Table
                                        columns={columnMessages}
                                        data={callData}
                                        setData={setCallData}
                                        skipPageReset={skipPageReset}
                                        pagesize={5}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>}
                {currentView === 'log' && <>
                    <div className="card mb-4">
                        <div className="card-header">
                            <i className="fas fa-table me-1"></i>
                            Call records
                        </div>
                        <div className="card-body">

                            <Table
                                columns={columnCallRecords}
                                data={callData}
                                setData={setCallData}
                                skipPageReset={skipPageReset}
                                pagesize={5}
                            />
                        </div>
                    </div>
                    <div className="card mb-4">
                        <div className="card-header">
                            <i className="fas fa-table me-1"></i>
                            Email/SMS records
                        </div>
                        <div className="card-body">
                            <Table
                                columns={columnMessageRecords}
                                data={callData}
                                setData={setCallData}
                                skipPageReset={skipPageReset}
                                pagesize={5}
                            />
                        </div>
                    </div>
                </>}
            </div>
        </>
    );
}

export default AdminLogs;
